import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/en-ie';
import 'moment/locale/nl';

'use strict';

class Search {
  constructor(elem) {
    this.elem = elem;
    const allSearchForms = document.querySelectorAll('.js-search-engine');
    this.othersSearchForms = Array.from(allSearchForms).filter((searchForm) => {
      return searchForm !== this.elem;
    });

    this.inputLocation = this.elem.querySelector('[name="location"]');
    this.inputArrival = this.elem.querySelector('[name="arrival"]');
    this.inputArrivalBeautify = this.elem.querySelector('[name="arrival-beautify"]');
    this.inputDeparture = this.elem.querySelector('[name="departure"]');
    this.inputDepartureBeautify = this.elem.querySelector('[name="departure-beautify"]');
    this.inputType = this.elem.querySelector('[name="type"]');
    this.inputPeoples = this.elem.querySelector('[name="peoples"]');
    this.inputAdults = this.elem.querySelector('[name="adults"]');
    this.inputChildren = this.elem.querySelector('[name="children"]');
    this.inputInfants = this.elem.querySelector('[name="infants"]');
    
    this.events();
  }

  events() {
    /* Location change */
    if (this.inputLocation) {
      this.inputLocation.addEventListener('change', () => {
        this.othersSearchForms.forEach((otherSearchForm) => {
          const otherInputLocation = otherSearchForm.querySelector('[name="location"]');
          otherInputLocation.value = this.inputLocation.value;
        });
      });
    }

    /* Arrival change */
    if (this.inputArrival) {
      this.inputArrival.addEventListener('change', () => {
        this.othersSearchForms.forEach((otherSearchForm) => {
          const otherInputArrival = otherSearchForm.querySelector('[name="arrival"]');
          const otherInputArrivalBeautify = otherSearchForm.querySelector('[name="arrival-beautify"]');
          otherInputArrival.value = this.inputArrival.value;
          otherInputArrivalBeautify.value = moment(this.inputArrival.value).format('ll');
        });
      });
    }

    /* Departure change */
    if (this.inputDeparture) {
      this.inputDeparture.addEventListener('change', () => {
        this.othersSearchForms.forEach((otherSearchForm) => {
          const otherInputDeparture = otherSearchForm.querySelector('[name="departure"]');
          const otherInputDepartureBeautify = otherSearchForm.querySelector('[name="departure-beautify"]');
          otherInputDeparture.value = this.inputDeparture.value;
          otherInputDepartureBeautify.value = moment(this.inputDeparture.value).format('ll');
        });
      });
    }

    /* Peoples change */
    if (this.inputPeoples) {
      this.inputPeoples.addEventListener('change', () => {
        this.othersSearchForms.forEach((otherSearchForm) => {
          const otherinputPeoples = otherSearchForm.querySelector('[name="peoples"]');
          otherinputPeoples.value = this.inputPeoples.value;
        });
      });
    }

    /* Adults change */
    if (this.inputAdults) {
      this.inputAdults.addEventListener('change', () => {
        this.othersSearchForms.forEach((otherSearchForm) => {
          const otherinputAdults = otherSearchForm.querySelector('[name="adults"]');
          otherinputAdults.value = this.inputAdults.value;
        });
      });
    }

    /* Children change */
    if (this.inputChildren) {
      this.inputChildren.addEventListener('change', () => {
        this.othersSearchForms.forEach((otherSearchForm) => {
          const otherinputChildren = otherSearchForm.querySelector('[name="children"]');
          otherinputChildren.value = this.inputChildren.value;
        });
      });
    }

    /* Infants change */
    if (this.inputInfants) {
      this.inputInfants.addEventListener('change', () => {
        this.othersSearchForms.forEach((otherSearchForm) => {
          const otherinputInfants = otherSearchForm.querySelector('[name="infants"]');
          otherinputInfants.value = this.inputInfants.value;
        });
      });
    }
  }
}

const searchEngines = document.querySelectorAll('.js-search-engine');
searchEngines.forEach((searchEngine) => {
  searchEngine.jsSearch = new Search(searchEngine);
});
